import { useContext } from "react";
import LicenseCheckContext from "license/LicenseCheckContext";
export default function useLicenseCheck() {
  const context = useContext(LicenseCheckContext);
  if (context === void 0) {
    throw new Error("useLicenseCheck must be used within a LicenseCheckProvider.");
  }
  return context;
}
